export default "/_next/static/images/david-cane-5c989b9f0a32b7571edc4c111a2327fd.png";